import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';
import { requestLogModel } from '@/models/api/requestLog.model';

export const activityLogModel = (data) => ({
    uuid: data.uuid,
    log_name: data.log_name,
    event: data.event,
    description: data.description,
    subjectType: data.subject_type,
    subjectId: data.subject_id,
    causerType: data.causer_type,
    properties: data.properties,
    performance: data.performance ? {
        memoryPeakMb: data.performance?.memory_peak_mb,
        memoryCurrentMb: data.performance?.memory_current_mb,
        duration_ms: data.performance?.duration_ms,
    } : null,
    oldValues: data.old_values,
    newValues: data.new_values,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    updatedAt: filtersHelper.getDateTimeFormat(data.updated_at),
    user: data.user ? userModel(data.user) : null,
    requestLog: data.request_log ? requestLogModel(data.request_log) : null,
});